
export default function (state) {
    return function (value) {
        return state && (typeof value === 'string' ? value.trim() !== '' : !!value);
    }
}
